import type { ArtBookPage } from '../definitions/ArtBook'
import { Spinner } from './SiteShell'
import { WatermarkedImage } from './WatermarkedImage'

export function BookCover({ title, imageUrl, compact = false }: { title: string; imageUrl: string; compact?: boolean }) {
  return (
    <figure className={`book-cover-wrap ${compact ? 'book-cover-wrap-compact' : ''}`} aria-label={`${title || 'Personalized book'} front cover`}>
      <div className="book-cover">
        <div className="book-cover-art">
          {imageUrl ? <WatermarkedImage src={imageUrl} alt="Personalized book cover" coverLayout /> : <Spinner label="Creating cover" />}
        </div>
      </div>
      <figcaption><strong>Front cover</strong><span>Print preview</span></figcaption>
    </figure>
  )
}

export function BookSpread({ page, coverImageUrl, editable, onCover, onToggle, onRetry }: {
  page: ArtBookPage
  coverImageUrl: string
  editable?: boolean
  onCover?: () => void
  onToggle?: () => void
  onRetry?: () => void
}) {
  return (
    <article className={`book-spread-wrap ${page.isActive === false ? 'is-disabled' : ''}`}>
      {editable && (
        <div className="spread-actions">
          <button className={page.generatedImageUrl === coverImageUrl ? 'is-selected' : ''} onClick={onCover} title="Use for cover">
            ♥ <span>{page.generatedImageUrl === coverImageUrl ? 'Cover' : 'Make cover'}</span>
          </button>
          <button onClick={onToggle}>{page.isActive === false ? '↺ Include' : '× Exclude'}</button>
        </div>
      )}
      <figure className="book-spread">
        <div className="spread-page">
          {page.generatedImageUrl
            ? <WatermarkedImage src={page.generatedImageUrl} alt={page.pageTitle || `Generated page ${page.pageNumber}`} />
            : page.generateState === 'failed'
              ? <div className="failed-page-state" role="alert"><strong>Page {page.pageNumber} didn’t finish</strong><span>{page.generationError || 'Your completed pages are safe. Try this page again.'}</span>{onRetry && <button type="button" onClick={onRetry}>Try this page again</button>}</div>
              : page.generateState === 'loading'
                ? <div className="pending-page-state" role="status"><Spinner label={`Creating page ${page.pageNumber}`} /><strong>Illustrating now</strong><span>It will appear here when ready</span></div>
                : <div className="pending-page-state is-queued" role="status"><span className="queued-mark" aria-hidden="true" /><strong>Waiting its turn</strong><span>Page {page.pageNumber} is safely in the queue</span></div>}
        </div>
        <figcaption><span>Page {page.pageNumber}</span>{page.pageTitle && <strong>{page.pageTitle}</strong>}</figcaption>
      </figure>
    </article>
  )
}
